module.exports = __webpack_public_path__ + "img/icon.038cddf5.png";